import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import logo from '../../assets/images/logos/OP36_clean_icon_orange.png'
import SubmitButton from '../common/buttons/SubmitButton'

import classes from './MaintenancePage.module.scss'

const MaintenancePage = () => {
  const { t } = useTranslation()

  return (
    <div className={classNames(classes.programRegistrationPrompt, 'd-flex justify-content-center align-items-center')}>
      <main className={classNames(classes.promptContent, 'd-flex flex-column justify-content-center align-items-center')}>
        <img src={logo} height={120} width={120} alt={t('maintenance.logoAlt')} className='mb-5' />

        <h1 className={classes.titleText}>{t('maintenance.title')}</h1>

        <h3 className={classes.subtitleText}>{t('maintenance.body')}</h3>

        <SubmitButton
          className={classes.actionLink}
          onClick={() => window.location.reload()}
          buttonMessage={t('maintenance.reload')}
        />
      </main>
    </div>
  )
}

export default MaintenancePage
